'use strict';

angular.module('systemOwnerUserRequestRoutes', ['systemOwnerUserRequestControllers',
                                                'services.authenticatedUser'])

.config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
    $stateProvider
        .state('systemOwnerUserRequest', {
            url: '/SystemOwner/UserRequest',
            templateUrl: require('./MainSystemOwnerUserRequest.tpl.html'),
            controller: 'MainSystemOwnerUserRequestController',
            resolve: {
                authUser: ['authenticatedUserService', function (service) {
                    return service.getAuthenticatedUser();
                }],
                cardsToProcess: ['systemOwnerUserRequestService', function (service) {
                    return service.getCardsToProcess();
                }]
            }
        });
}]);